import React, { Component } from 'react';
import about from "assets/img/about.png";

class AboutUs extends Component{
 	render(){
  	return(
    	<section className="section first_section not_home grey">
        <div className="section_title">
          <img src={about} alt="aboutImage" />
          <h2 className="mt-20">About Us</h2>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p className="about_text">
                MusicAdjudicators.com was developed by PhotoVision, Inc. We serve educators and music programs with our products offered by tour and festival operators. We capture and preserve the memories made on these trips to have for a lifetime of enjoyment.
              </p>
            </div>
          </div>
        </div>
      </section>
  	);
  }
}
export default AboutUs;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/AboutUs.jsx